import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/axios';
import { GET_SUPPLY_CHAIN_INFORMATIONS_KEY } from '@/keys';
import type { SupplyChainInformation } from '@/types/core/purchase-order/supply-chain-information';

const getSupplyChainInformations = async (
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  token?: string,
): Promise<SupplyChainInformation[]> => {
  const response = await api.get<SupplyChainInformation[]>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/supply-chain-informations`,
    { params: { token } },
  );
  return response.data;
};

export const useGetSupplyChainInformations = (
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  token?: string,
): UseQueryResult<SupplyChainInformation[], Error> =>
  useQuery({
    queryKey: [
      ...GET_SUPPLY_CHAIN_INFORMATIONS_KEY,
      productionDeclarationId,
      materialId,
      commodityOriginId,
      token ?? '',
    ],
    queryFn: () =>
      getSupplyChainInformations(
        productionDeclarationId,
        materialId,
        commodityOriginId,
        token,
      ),
    enabled: Boolean(
      productionDeclarationId && materialId && commodityOriginId,
    ),
  });
